import { render, staticRenderFns } from "./KullaniciRapor.vue?vue&type=template&id=65614f6f&"
import script from "./KullaniciRapor.vue?vue&type=script&lang=js&"
export * from "./KullaniciRapor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports